import PropTypes from 'prop-types';
import React from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';

// Modern Google Maps-style pin using SVG
const customIcon = L.divIcon({
	html: `<svg width="24" height="36" viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg">
		<path d="M16 0C7.2 0 0 7.2 0 16c0 11.2 16 28 16 28s16-16.8 16-28c0-8.8-7.2-16-16-16z" 
			fill="#EA4335"/>
		<circle cx="16" cy="16" r="6" fill="white"/>
	</svg>`,
	className: 'leaflet-svg-icon',
	iconSize: [24, 36],
	iconAnchor: [12, 36],
	popupAnchor: [0, -36]
});

const PopupMarker = ({ center, infoWindow }) => (
	<Marker position={[center.latitude, center.longitude]} icon={customIcon}>
		{infoWindow && <Popup>
			<span>{infoWindow(center)}</span>
		</Popup>}
	</Marker>
);

const MarkersList = ({ markers, infoWindow }) => {
	const items = markers.map((center) => (
		<PopupMarker key={center.id} center={center} infoWindow={infoWindow} />
	));
	return <div style={{ display: "none" }}>{items}</div>;
};
MarkersList.propTypes = {
	markers: PropTypes.array.isRequired
};

const MapComponent = ({ latitude, longitude, isSingleMarker, markers, defaultZoom,
	onMarkerClick, activeMarkerKey, height, infoWindow, onMapClick }) => {

	const center = [latitude, longitude];
	const centers = isSingleMarker ? [{ latitude, longitude }] : markers;

	return (
		<Map center={center} zoom={defaultZoom || 18} style={{ marginBottom: 10, height: height || `300px` }}>
			<TileLayer
				attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
				url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
			/>
			<MarkersList markers={centers} infoWindow={infoWindow} />
		</Map>
	);
}

export default MapComponent;

//import React from 'react';
//import Config from 'Config';
//import {
//	withScriptjs,
//	withGoogleMap,
//	GoogleMap,
//	Marker
//} from 'react-google-maps';

//const MapWithMarkers = withScriptjs(withGoogleMap(props =>
//	<GoogleMap defaultZoom={props.defaultZoom || 18} defaultCenter={{ lat: props.latitude, lng: props.longitude }}
//		onClick={props.onMapClick}>
//		{props.isSingleMarker && <Marker position={{ lat: props.latitude, lng: props.longitude }} />}
//		{props.markers && props.markers.map(marker => <Marker key={marker.id}
//			position={{ lat: marker.latitude, lng: marker.longitude }}
//			onClick={() => props.onMarkerClick(marker)}>
//			{props.activeMarkerKey == marker.id && props.infoWindow(marker)}
//		</Marker>)}
//	</GoogleMap>
//));

//const MapComponent = ({ latitude, longitude, isSingleMarker, markers, defaultZoom,
//	onMarkerClick, activeMarkerKey, height, infoWindow, onMapClick }) => {
//	const googleApiKey = Config.googleApiKey;

//	return <MapWithMarkers
//		defaultZoom={defaultZoom}
//		latitude={latitude}
//		longitude={longitude}
//		isSingleMarker={isSingleMarker}
//		markers={markers}
//		activeMarkerKey={activeMarkerKey}
//		onMarkerClick={onMarkerClick}
//		onMapClick={onMapClick}
//		infoWindow={infoWindow}
//		googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&v=3.exp&libraries=geometry,drawing,places`}
//		loadingElement={<div style={{ height: `100%` }} />}
//		containerElement={<div style={{ height: height || `300px` }} />}
//		mapElement={<div style={{ height: `100%` }} />}
//	/>;
//};

//export default MapComponent;